import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authorizationStore from "../auth/authorizationStore";
import jwtUtils from "../utils/jwtUtils";
import { LoadingSpinner } from "components/common";
import { Routes } from "../../routes";
import { RootState } from "../../redux/store";
import NetworkHelper from "../network/helpers/network/helper/NetworkHelper";
import AuthHelper from "../auth/helpers/AuthHelper";
import { setIsAdmin } from "../../redux/metadata/slice/metadataSlice";

export const withAdminCheck = WrappedComponent => {
  const HOC = (props: any) => {
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const eventEdition = useSelector((state: RootState) => state.eventEdition.eventEdition);

    useEffect(() => {
      if (AuthHelper.isWithoutAuth()) {
        setIsLoading(false);
        return;
      }
      checkAdminRole();
    }, []);

    const checkAdminRole = async () => {
      try {
        const token = await authorizationStore.getToken();
        const isOnline = await NetworkHelper.isConnected();

        if (!token) {
          if (!isOnline) {
            dispatch(setIsAdmin(true));
          }
          setIsLoading(false);
          return;
        }

        const isRxAdmin = jwtUtils.isLoggedUserRxAdmin(token);
        const isBuAdmin = jwtUtils.isLoggedUserBUAdmin(token);
        const gbsCode = eventEdition?.gbsCode ?? "";
        const isTempStaff = jwtUtils.isLoggerUserTempStaff(token, gbsCode);
        const isUserManager = jwtUtils.isLoggedUserManager(token, gbsCode);
        const isUserFinance = jwtUtils.isLoggedUserFinance(token, gbsCode);

        if (isRxAdmin || isBuAdmin || isTempStaff || isUserManager || isUserFinance) {
          dispatch(setIsAdmin(true));
          setIsLoading(false);
          return;
        }

        dispatch(setIsAdmin(false));
        setIsLoading(false);
        navigate(Routes.unauthorized, { replace: true });
      } catch (e) {
        console.error(e);
      }
    };

    if (isLoading) {
      return <LoadingSpinner />;
    }

    return <WrappedComponent {...props} />;
  };

  return HOC;
};
